import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../core/Modal';
import Loading from '../../../core/Loading';
import { StyledModalContent } from '../../../core/Modal/style';
import WithholdingRRHH from '../../../views/Employee/Withholding/WithholdingRRHH';
import {
  getUserBySearchID,
  sendEmailUsersRegistration,
  sendEmailUsersDeregistration,
  sendEmailIrpfAdmin
} from '../../../../utils/apiWithholding';

class WithholdingWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipState: false,
      error: {
        state: false,
        data: null
      },
      employeeSearched: {},
      employeeId: '',
      sendEmailsToGroup: false,
      getCertificate: null,
      isEmailSent: null,
      loading: null,
      searchModal: false,
      showList: false
    };
    this.employeeIdInput = React.createRef();
  }

  tooltipHandler = () => {
    const { tooltipState } = this.state;

    this.setState({
      tooltipState: !tooltipState
    });
  };

  navigateToNextStep = nextStep => {
    const {
      setSpainAsCountryHandler,
      setIsScheduleCollectionHandler,
      history,
      mainUserData
    } = this.props;

    if (mainUserData.actions.length === 0) {
      this.setState({
        error: {
          state: true,
          data: 'No dispone de permisos para crear o visualizar envíos'
        }
      });
    } else {
      if (nextStep === '/schedule_collection') {
        setSpainAsCountryHandler();
        setIsScheduleCollectionHandler(true);
      }
      history.push(nextStep);
    }
  };

  searchEmployeeById = id => {
    this.setState({ employeeId: id });

    getUserBySearchID(id)
      .then(employee => {
        if (Object.entries(employee).length !== 0) {
          this.setState({
            employeeSearched: employee,
            selectedYear: 2021,
            getCertificate: true
          });
        } else {
          this.setState({
            searchModal: false,
            getCertificate: false,
            employeeSearched: null
          });
        }
      })
      .catch(error => {
        this.setState({
          searchModal: false,
          getCertificate: false,
          employeeSearched: null
        });
        throw error;
      });
  };

  handleWithholding = value => {
    const { showList } = this.state;
    switch (value) {
      case 'ver_historico':
        this.setState({ showList: !showList });
        break;
      case 'bajas_mail':
        this.handleSendingFunction(sendEmailUsersDeregistration);
        break;
      case 'altas_mail':
        this.handleSendingFunction(sendEmailUsersRegistration);
        break;
      case 'buscador':
        this.setState({
          searchModal: true,
          sendEmailsToGroup: false,
          showList: false
        });
        break;
      default:
        break;
    }
  };

  handleSendingFunction = sendingFunction => {
    this.setState({ loading: true, showList: false });
    setTimeout(() => {
      this.setState({
        sendEmailsToGroup: true,
        isEmailSent: true,
        loading: false,
        showList: true
      });
      sendingFunction();
    }, 3000);
  };

  sendEmailById(id) {
    const { employeeSearched, selectedYear } = this.state;
    const data = [
      {
        email: employeeSearched.email,
        userName: employeeSearched.userName,
        userId: id,
        year: Math.floor(selectedYear)
      }
    ];
    sendEmailIrpfAdmin(data);
    this.setState({
      isEmailSent: true
    });
  }

  render() {
    const { userName, roles } = this.props;
    const {
      error,
      searchModal,
      loading,
      showList,
      employeeId,
      employeeSearched,
      selectedYear,
      isEmailSent,
      getCertificate,
      sendEmailsToGroup
    } = this.state;

    const isRRHH = roles.includes('ROLE_ACCESS_RRHH');
    const isAdmin = roles.includes('ROLE_ADMIN_A3MIL');

    return (
      <>
        {!isRRHH && !isAdmin && (
          <Modal
            title="Centro de Gestión de Certificados de Retención"
            clickCloseIcon={() => this.props.history.push('/')}
          >
            <StyledModalContent>
              El usuario no tiene los permisos necesarios.
            </StyledModalContent>
          </Modal>
        )}
        {(isRRHH || isAdmin) && (
          <WithholdingRRHH
            key="editor1"
            name={userName}
            error={error}
            isRRHH={isRRHH}
            isAdmin={isAdmin}
            showList={showList}
            loading={loading || searchModal}
            searchModal={searchModal}
            year={selectedYear}
            getCertificate={getCertificate}
            employeeId={employeeId}
            autofocus
            employeeSearched={employeeSearched}
            searchEmployeeById={id => this.searchEmployeeById(id)}
            sendEmailById={id => this.sendEmailById(id)}
            onCloseModal={() =>
              this.setState({ error: { state: false, data: null } })
            }
            onCloseSearchModal={() =>
              this.setState({ searchModal: false, getCertificate: null })
            }
            handleWithholding={value => this.handleWithholding(value)}
            roles={roles}
          />
        )}
        {loading && <Loading txt="Enviando retenciones" />}
        {searchModal === false &&
          getCertificate === false &&
          employeeSearched === null && (
            <Modal
              center
              title="Certificado de Retención"
              clickCloseIcon={() =>
                this.setState({
                  getCertificate: null,
                  searchModal: false,
                  employeeSearched: {}
                })
              }
            >
              <StyledModalContent>
                El usuario seleccionado no existe en la tabla.
              </StyledModalContent>
            </Modal>
          )}
        {searchModal && getCertificate === false && (
          <Modal
            center
            title="Certificado de Retención"
            clickCloseIcon={() => this.setState({ getCertificate: null })}
          >
            <StyledModalContent>
              El usuario seleccionado no tiene certificados.
            </StyledModalContent>
          </Modal>
        )}
        {isEmailSent && (
          <Modal
            center
            title="Certificado de Retención"
            clickCloseIcon={() =>
              this.setState({
                isEmailSent: false,
                searchModal: false,
                getCertificate: null
              })
            }
          >
            <StyledModalContent sendEmailsToGroup>
              {sendEmailsToGroup === true
                ? 'Las retenciones se han enviado correctamente'
                : 'La retención se ha enviado correctamente'}
            </StyledModalContent>
          </Modal>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  userId: user.user.userId,
  userName: `${user.user.name}`,
  roles: user.user.roles
});

export default connect(mapStateToProps)(WithholdingWrapper);
